const handlePodcastSelect = () => {
  $('.js-podcast-select').on('click', '.collection-select-dropdown__trigger', function() {
    const $this = $(this);
    const $parent = $this.closest('.collection-select-dropdown');

    $parent.toggleClass('is-open');
  });
}

/**
 * Close Dropdown On Click Outside
 */
const closeDropdownOnClickOutside = () => {
  $(document).on('click', function(event) {
    const $trigger = $('.js-podcast-select.is-open');

    if (! $trigger.length) {
      return;
    }

    $trigger.each(function(index, el) {
      const $this = $(this);

      if($this !== event.target && ! $this.has(event.target).length) {
        $this.removeClass('is-open');
      }
    });
  });
}

closeDropdownOnClickOutside();

$(document).ready(function() {
  handlePodcastSelect();
});
